import { svgs } from "../assets/svgs"

export const Loader = ({ color = '' }) => {
    return (
        <div className={`loader ${color}`}>
            <div className='triangle triangle1'>{svgs.loaderTriangleLarge}</div>
            <div className='triangle triangle2'>{svgs.loaderTriangleMedium}</div>
            <div className='triangle triangle3'>{svgs.loaderTriangleSmall}</div>
        </div>
    )
}